/* Real gallery photos for the live gallery pages.
   Web-optimized copies live in /public/images/gallery-v2/<category>/, generated
   from the foundation's photo folders. Each page imports its own array so the
   Awareness / Blood Donation Camps galleries show their
   own real photos instead of the shared demo set. */

const B = process.env.PUBLIC_URL + "/images/gallery-v2/";

const build = (folder, prefix, count, caps) =>
    Array.from({ length: count }, (_, i) => ({
        src: `${B}${folder}/${prefix}-${String(i + 1).padStart(2, "0")}.jpg`,
        cap: caps ? caps[i % caps.length] : "",
    }));

export const AWARENESS_PHOTOS = build("awareness", "awareness", 10);

export const CAMP_PHOTOS = build("blood-donation-camps", "camp", 11);
